export default __webpack_public_path__ + "static/media/setting.848a2251.svg";